import { useState } from 'react';

/** The reject-reason popover form (text + trim/submit/reset) shared by every conformity
 * reject control — the file row's compact pill and the viewer's footer bar both need the
 * exact same state machine, just laid out differently. */
export function useConformityReasonPopover(
  documentId: string,
  onReject?: (documentId: string, reason: string) => void,
) {
  const [reason, setReason] = useState('');
  const [popoverOpen, setPopoverOpen] = useState(false);

  const submit = () => {
    onReject?.(documentId, reason.trim());
    setReason('');
    setPopoverOpen(false);
  };

  return { reason, setReason, popoverOpen, setPopoverOpen, submit };
}
